import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.fi{gap:24px;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.d2{margin-bottom:24px;}.ssr-plugin'
import '.fj{gap:20px;}.ssr-plugin'
import '.u{border-radius:16px;}.ssr-plugin'
import '.bg{aspect-ratio:1/1;}.ssr-plugin'
import '.fk{width:112px;}.ssr-plugin'
import '.fl{height:112px;}.ssr-plugin'
import '.fm{min-width:112px;}.ssr-plugin'
import '.fn{min-height:112px;}.ssr-plugin'
import '.d6{object-fit:cover;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.fo{align-items:left;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.fp{font-size:16px;}.ssr-plugin'
import '.fq{margin-bottom:8px;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.cb{gap:12px;}.ssr-plugin'
import '.fr{margin-bottom:16px;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.ez{height:1px;}.ssr-plugin'
import { styled } from 'inlines'
import { VoteButton } from './VoteButton.js'
import { colors } from '../utils/colors.js'
import { Flag } from './Flag.js'
import { getVotingRegionName } from '../hooks/useVotingRegion.js'
import { MOBILE } from '../utils/breakpoints.js'
import { parseContestantImageSrc } from '../utils/parseImageSrc.js'
import { useDictionary } from '../hooks/useDictionary.js'

type SingleCartItemProps = {
  isPhone?: boolean
  item: {
    name: string
    song: string
    votingRegion: string
    image: { src?: string }
  }
  votes?: Record<string, number>
  setVotes?: (selected: Record<string, number>) => void
  maxed?: boolean
  price?: number
  currency?: string
  lang?: string
  ddi?: string
}

export const SingleCartItem = ({
  isPhone,
  item,
  votes,
  setVotes,
  maxed,
  price,
  currency,
  lang,
  ddi,
}: SingleCartItemProps) => {
  const { name, song, votingRegion, image } = item

  const votingRegionName = getVotingRegionName(votingRegion, lang as string)
  const { vote } = useDictionary()

  return (
    <div className="o p fi ap d2"
      id={`cart-page-item-${votingRegion}`}
    >
      <div className="o fj"
      >
        <img className="u bg fk fl fm fn d6"
          src={parseContestantImageSrc(image?.src as string, 128)}
          style={{
            border: `1px solid ${colors.border}`,}}
        />
        <div className="o bb fo p a"
        >
          <styled.p className="fp fq"
            style={{
              [MOBILE]: { fontSize: '14px' },
            }}
          >
            {isPhone && ddi + ' · '} {name} · {song}
          </styled.p>
          <div className="o v cb fr"
          >
            <Flag code={votingRegion} width={16} height={16} />
            <styled.p className="fp"
              style={{ [MOBILE]: { fontSize: '14px' } }}
            >
              {votingRegionName}
            </styled.p>
          </div>
          <div className="o a am v"
          >
            {isPhone ? (
              <styled.p className="fp"
                style={{ [MOBILE]: { fontSize: '14px' } }}
              >
                1 {vote}
              </styled.p>
            ) : (
              <styled.div>
                <VoteButton
                  id={`cart-vote-btn-${votingRegion}`}
                  votes={votes}
                  setVotes={setVotes}
                  votingRegion={votingRegion}
                  maxed={maxed}
                />
              </styled.div>
            )}
            <styled.p className="fp"
              style={{ [MOBILE]: { fontSize: '14px' } }}
            >
              {currency}{' '}
              {(() => {
                const v = votes?.[votingRegion]
                if (v === undefined)
                  console.warn(
                    'SingleCartItem: votes missing for',
                    votingRegion,
                  )
                if (price === undefined)
                  console.warn('SingleCartItem: price missing')
                return (((v ?? 0) * (price ?? 0)) / 100).toFixed(2) // SAFE: zero when data not yet loaded
              })()}
            </styled.p>
          </div>
        </div>
      </div>

      <div className="ez a"
        style={{
          background: `${colors.border}`,}}
      />
    </div>
  )
}
